<div class="">
  <ion-card class="ion-no-margin rounded-none" [class]="{'w-64': small}">
    <ion-card-header class="ion-no-padding" [routerLink]="entry.getLink()">
      <ion-card-title class="">
        @if (entry.getMainImage() !== null) {
          @if (entry.getMainImage()?.includes('mp4')) {
            <video class="aspect-video z-10 object-cover object-top w-full" autoplay [muted]="'muted'" loop controls>
              <source src="{{ entry.getMainImage() }}" type="video/mp4">
            </video>
          } @else if (entry.getMainImage()?.includes('webm')) {
            <video class="aspect-video z-10 object-cover object-top w-full" autoplay [muted]="'muted'" loop controls>
              <source src="{{ entry.getMainImage() }}" type="video/webm">
            </video>
          } @else if (entry.getMainImage()?.includes('ogv')) {
            <video class="aspect-video z-10 object-cover object-top w-full" autoplay [muted]="'muted'" loop controls>
              <source src="{{ entry.getMainImage() }}" type="video/ogv">
            </video>
          } @else if (entry.getMainImage()?.includes('mov')) {
            <video class="aspect-video z-10 object-cover object-top w-full" autoplay [muted]="'muted'" loop controls>
              <source src="{{ entry.getMainImage() }}" type="video/mov">
            </video>
          } @else {
            <pinch-zoom [autoZoomOut]="true" [overflow]="'visible'" class="z-[100]" [backgroundColor]="'transparent'" [wheel]="false">
              <img src="{{ entry.getMainImage() }}" alt="{{ entry.title }}" [routerLink]="entry.getLink()"
                   class="w-full card-header-image"
                   [class]="{'h-48 md:h-96': !small, 'w-64': small}"/>
            </pinch-zoom>
          }
        } @else {
          <img [src]="'/assets/img/'+defaultImage" alt="{{ entry.title }}" [routerLink]="entry.getLink()"
               class="w-full card-header-image"
               [class]="{'h-48 md:h-96': !small, 'w-64': small}"/>
        }
      </ion-card-title>
    </ion-card-header>

    <ion-card-content class="ion-no-padding min-h-[8.5rem] h-[8.5rem] md:min-h-[6rem] md:h-[6rem]">
      @if (entry.title) {
        <div class="py-3">
          <ion-card-title
            class=""
            [routerLink]="entry.getLink()"
            [class.text-2xl]="small"
            [class.truncate]="small"
            [class.text-3xl]="!small"
            [class.line-clamp-2]="!small"
          >
            <a class="!text-inherit" [routerLink]="entry.getLink()">
              {{ entry.title }}
            </a>
          </ion-card-title>
        </div>
      }


      <div class="flex items-center justify-between">
        <div class="flex items-center flex-auto overflow-hidden">
          <div class="shrink-0 w-6 sm:w-8">
            <ion-nav-link class="cursor-pointer" [routerLink]="'/'+entry.owner.url">
              <img *ngIf="entry.owner.logo"
                   [src]="entry.owner.logo"
                   class="w-full rounded-full border bg-white"
                   [alt]="entry.owner.title"/>
            </ion-nav-link>
          </div>
          <div class="pl-3 overflow-hidden">
            @if (showOwner) {
              @if (entry.owner.url) {
                <ion-nav-link class="cursor-pointer" [routerLink]="'/'+entry.owner.url">
                  <div class="font-bold truncate">
                    <a class="!text-inherit" [routerLink]="'/'+entry.owner.url">
                      {{ entry.owner.title }}
                    </a>
                  </div>
                </ion-nav-link>
              } @else {
                <div class=" font-bold text-gray-600">
                  {{ entry.owner.title }}
                </div>
              }
            }

            <div class="flex items-center -mt-1">
              <ng-icon name="heroCalendar" class="mr-2"/>
              {{ entry.event_date_start | date: 'dd.MM.yyyy HH:mm' }}
            </div>
          </div>
        </div>

        @if (showActionButtons) {
          <div class="flex flex-none items-center h-full pl-6">
            <app-timeline-entry-action-buttons [entry]="entry"/>
          </div>
        }
      </div>
    </ion-card-content>
  </ion-card>
</div>
